module.exports = __webpack_public_path__ + "img/head_guarantee_699.68d83a38.png";